export const ChatKeys = {
	all: ["chat"] as const,
	list: () => [...ChatKeys.all, "list"] as const,
	messages: (conversationId: number | null) =>
		[...ChatKeys.all, "messages", conversationId] as const,
	attachmentImage: (attachmentId: number) =>
		[...ChatKeys.all, "attachment-image", attachmentId] as const,
};
